// extracted by mini-css-extract-plugin
export default {"statsSection":"Stats_statsSection__RX4v1"};